export default __webpack_public_path__ + "static/media/qualiteprestations.a2ebbfd7.svg";